<template>
	<a-drawer title="新增监控点"  :visible="showFlag" width="480" @close="closeView(false)" :destroyOnClose="true">
		<a-form-model  ref="addForm"  :model="addModel"   :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :rules="rules" >
			<a-form-model-item label="给水号" prop="meterApid">
				<a-input-search  v-model="addModel.meterApid" enter-button @search="searchApId()" placeholder="请先查询给水号"/>
			</a-form-model-item>
			<a-form-model-item label="水表地址" prop="meterAddr">
				<a-input  v-model="addModel.meterAddr" readonly disabled/>
			</a-form-model-item>
			<a-form-model-item label="水表口径" prop="caliber">
				<a-input  v-model="addModel.caliber" readonly disabled/>
			</a-form-model-item>
			<a-form-model-item label="监控点名称" prop="monitorName">
				<a-input  v-model="addModel.monitorName"  placeholder="请输入监控点名称"/>
			</a-form-model-item>
			<a-form-model-item label="监控点地址" prop="monitorAddress">
				<a-input  v-model="addModel.monitorAddress"  placeholder="请输入监控点地址"/>
			</a-form-model-item>
			<a-form-model-item label="监控点坐标" prop="monitorPoint">
				<a-input-search  v-model="addModel.monitorPoint" @search="showMap()"
								placeholder="点击右侧按钮,从地图上选择坐标经纬度">
					<a-button slot="enterButton">
						<a-icon type="environment" />
					</a-button>
				</a-input-search>
			</a-form-model-item>
			<a-form-model-item label="所属群组" prop="groupName">
				<a-select v-model="addModel.groupName">
					<a-select-option v-for="(item,index) in groupList"  :value="item" :key="item">{{item}}</a-select-option>
				</a-select>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
			<a-button icon="close" @click="closeView(false)" style="margin-right: 0.625rem;">取 消</a-button>
			<a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</a-drawer>
</template>

<script>
	 export default {
		data(){
			return {
				submitFlag:false,
				showFlag:false,
				addModel:{
					meterId:null,
					meterApid:null,
					meterAddr:null,
					caliber:null,
					monitorName:null,
					monitorAddress:null,
					monitorPoint:null,
					groupName:null,
					longitude:null,
					latitude:null,
				},
				groupList:["B13257","B23258","B33259"],
				rules:{
					meterApid:[{required:true,message:'请输入给水号',trigger: 'blur'},],
					monitorName:[{required:true,message:'请输入监控点名称',trigger: 'blur'}],
					monitorAddress:[{required:true,message:'请输入监控点地址',trigger: 'blur'}],
					monitorPoint:[{required:true,message:'请输入监控点坐标',trigger: 'blur'}],
					groupName:[{required:true,message:'请选择所属群组',trigger: 'blur'}],
				}, 
			}
		},
		methods: {
			showMap(){
				let url = "http://api.map.baidu.com/lbsapi/getpoint/index.html";
				window.open(url,"_blank");
			},
			closeView(flag) {
				this.showFlag = false;
				if(flag){
					this.$emit('refreshIt');
				}
			},
			showView(){
				this.showFlag = true;
			},
			searchApId(){
				let param = {
						apId:this.addModel.meterApid
				}
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_QUERY_METER_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						if(result){
							this.addModel.meterAddr = result.meterAddr;
							this.addModel.caliber = result.caliber;
							this.addModel.meterId = result.meterId;
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			doSubmit(){
				if(this.addModel.monitorPoint!=null){
					let array = this.addModel.monitorPoint.split(",");
					this.addModel.longitude = array[0];
					this.addModel.latitude = array[1];
				}
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_ADD_URL);
				this.Api.fetchPostWithForm(url,this.addModel).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('大表监控点新增成功');
						this.closeView(true);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			onSubmit(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					}
				});
			},
		},
	}
</script>

<style>
</style>
